/** The minimal shape this constraint reads: only `role` drives whether the precision is mandatory. */
type RoleDetailsRequirementShape = {
	readonly role: string | null;
};

/**
 * Generic over the minimal shape it reads, not over `BeneficiaryContactFormData` itself, so the
 * FormData never has to import its own constraint back (`guides/forms.md` §1.1). The precision only
 * qualifies the "other" role: any other role, including none, leaves it optional.
 */
function isRoleDetailsValid<T extends RoleDetailsRequirementShape>(
	value: string | null,
	formData: T,
): boolean {
	return formData.role !== 'other' || (value ?? '').trim() !== '';
}

export default isRoleDetailsValid;
